import { Todo, TodoEntity } from '../types/data';

/**
 * UI層のTodo（camelCase）をDB層のTodoEntity（snake_case）に変換
 */
export const toSnakeCase = (todo: Todo): TodoEntity => {
  return {
    id: todo.id,
    title: todo.title,
    body: todo.body,
    is_done: todo.done,
    is_canceled: todo.canceled,
    is_deleted: todo.deleted,
    start_at: todo.startAt,
    done_at: todo.doneAt,
    created_at: todo.createdAt,
    modified_at: todo.modifiedAt,
    habit_id: todo.habitId,
    todo_tag_ids: todo.todoTagIds,
    stock_items: todo.stockItems,
  };
};

/**
 * DB層のTodoEntity（snake_case）をUI層のTodo（camelCase）に変換
 */
export const toCamelCase = (todoEntity: TodoEntity): Todo => {
  return {
    id: todoEntity.id,
    title: todoEntity.title,
    body: todoEntity.body,
    done: todoEntity.is_done,
    canceled: todoEntity.is_canceled,
    deleted: todoEntity.is_deleted,
    startAt: todoEntity.start_at,
    doneAt: todoEntity.done_at,
    createdAt: todoEntity.created_at,
    modifiedAt: todoEntity.modified_at,
    habitId: todoEntity.habit_id,
    todoTagIds: todoEntity.todo_tag_ids,
    stockItems: todoEntity.stock_items,
  };
};

/**
 * Todo配列をTodoEntity配列に変換
 */
export const todosToSnakeCase = (todos: Todo[]): TodoEntity[] => {
  return todos.map(toSnakeCase);
};

/**
 * TodoEntity配列をTodo配列に変換
 */
export const todosToCamelCase = (todoEntities: TodoEntity[]): Todo[] => {
  return todoEntities.map(toCamelCase);
};

/**
 * LocalStorageから読み込んだデータの型チェックと変換
 * 古いcamelCaseデータと新しいsnake_caseデータの両方に対応
 */
export const parseStoredTodos = (storedData: string): Todo[] => {
  try {
    const parsed = JSON.parse(storedData);
    
    if (!Array.isArray(parsed)) {
      return [];
    }

    // データの最初の要素をチェックして形式を判定
    if (parsed.length === 0) {
      return [];
    }

    const firstItem = parsed[0];
    
    // snake_case形式かどうかをチェック（is_done フィールドの存在で判定）
    if ('is_done' in firstItem) {
      // snake_case形式 → camelCaseに変換
      return todosToCamelCase(parsed as TodoEntity[]);
    } else {
      // camelCase形式 → そのまま使用
      return parsed as Todo[];
    }
  } catch (error) {
    console.error('Failed to parse stored todos:', error);
    return [];
  }
};

/**
 * 既存のcamelCaseデータをsnake_caseに移行するためのユーティリティ
 */
export const migrateLegacyData = (legacyTodos: Todo[]): TodoEntity[] => {
  return todosToSnakeCase(legacyTodos);
};